import { Injectable } from '@angular/core';
import { BaseApiClientLabelsService } from './base-api-client-labels.service';

@Injectable({
  providedIn: 'root'
})
export class ApiClientLabelsService extends BaseApiClientLabelsService {}
